import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SearchUiService } from '../../services/search-ui.service';

@Component({
  selector: 'app-mobile',
  standalone: false,
  templateUrl: './mobile.component.html',
  styleUrl: './mobile.component.css'
})
export class MobileComponent implements OnInit {
  menuPrincipal:boolean=false;

  /* info del usuario*/
  public userData: any;
  public userJson:any;
  nombreUsuario:string="";
  noMostrar=false;

  isCollapsedPostVenta:boolean = false;
  isCollapsedSiniestro:boolean = false;
  user: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private searchUi: SearchUiService
  ) {
    // this.active = 0;
    //this.orientationTab = 'vertical';
    //this.viewModelsCars = false;
    this.isCollapsedPostVenta =false;
    this.isCollapsedSiniestro =false;
    this.authService.user$.subscribe(user => {
      this.user = user;
    });
    //this.isCollapsedSobreNosotros = false;
  }

  abrirBuscador(): void {
    this.menuPrincipal = false;
    this.searchUi.open();
  }
  ngOnInit(): void {
    this.user = this.authService.getUser();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const clickedInside = (event.target as HTMLElement).closest('.menu-principal');
    const clickedToggle = (event.target as HTMLElement).closest('.navbar-toggler');
    if (!clickedInside && !clickedToggle) {
      this.menuPrincipal = false;
    }
  }
  viewMenuPrincipal(): void {
    this.menuPrincipal = !this.menuPrincipal; // Alterna visibilidad del menú
  }

  noViewMenuPrincipal(): void {
    this.menuPrincipal = false; // Cierra el menú
  }

  logout(){
    this.authService.logout();
    this.router.navigate(['/login']).then(() => {
      setTimeout(() => {
        window.location.reload();
      }, 200);
    });
  }
}
